<div class="d-flex align-items-center">
    <button mat-flat-button class="custom-button-volver" (click)="goBack()">
        <mat-icon aria-hidden="false" aria-label="Volver" fontIcon="arrow_back" class="icon-volver mr-3"></mat-icon>
        Volver
    </button>
</div>
<div class="container-fluid bg-white p-5 mb-5 br-10">
    <h1>Administración de Procesos</h1>

    <div class="d-flex flex-row">
        <mat-chip-set class="mr-3">
            <mat-chip class="chip-info br-5">
                <strong>ID:</strong> {{ detail?.id }}
            </mat-chip>
        </mat-chip-set>

        <mat-chip-set>
            <mat-chip class="chip-info br-5">
                <strong>Nombre:</strong> {{ detail?.name }}
            </mat-chip>
        </mat-chip-set>
    </div>

    <mat-card class="simple-card mx-auto my-5">
        <mat-card-header>
            <mat-card-title class="font-size-title-card">
                <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                <strong>Procesos asignados</strong>
            </mat-card-title>
        </mat-card-header>

        <mat-card-content class="p-5">

            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>
                    <ng-container matColumnDef="modelo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear
                            sortActionDescription="Ordenado por modelo">Modelo</th>
                        <td mat-cell *matCellDef="let element">{{ element?.batchTemplate?.name ?
                            element?.batchTemplate?.name : element?.batchTemplate?.tag }}</td>
                    </ng-container>

                    <ng-container matColumnDef="frecuencia">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear
                            sortActionDescription="Ordenado por frecuencia">Frecuencia</th>
                        <td mat-cell *matCellDef="let element">{{ element?.frequency?.description ?
                            element?.frequency?.description : element?.frequency?.name }}</td>
                    </ng-container>

                    <ng-container matColumnDef="destino">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear
                            sortActionDescription="Ordenado por destino">Destino</th>
                        <td mat-cell *matCellDef="let element">{{ element?.destination?.type }}</td>
                    </ng-container>

                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef>Acciones</th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                            <button mat-mini-fab class="button-mini-fab-error" (click)="removeConfig(element)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="progress">
                        <th mat-cell *matCellDef="let element"></th>
                        <td mat-header-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length">
                            <mat-progress-bar *ngIf="isBatchConfigListLoading" mode="indeterminate"></mat-progress-bar>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    <tr mat-header-row *matHeaderRowDef="['progress']; sticky: true" class="progress-row"></tr>

                    <ng-container *ngIf="!isBatchConfigListLoading">
                        <tr class="mat-mdc-row" *matNoDataRow>
                            <td class="mat-mdc-cell text-center font-weight-500 loading-cell"
                                [attr.colspan]="displayedColumns.length">
                                No hay datos disponibles
                            </td>
                        </tr>
                    </ng-container>
                </table>
            </div>

            <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons aria-label="Seleccionar página">
            </mat-paginator>

        </mat-card-content>
    </mat-card>

    <mat-card class="simple-card mx-auto my-5">
        <mat-card-header>
            <mat-card-title class="font-size-title-card">
                <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                <strong>Asignación de procesos</strong>
            </mat-card-title>
        </mat-card-header>

        <mat-card-content class="p-5">
            <div [formGroup]="processAssignForm" class="stepper-container">
                <mat-stepper [linear]="true" [selectedIndex]="stepperIndex" #stepper>
                    <mat-step label="Modelo" [stepControl]="processAssignForm.controls.modelo">
                        <div class="col-12 d-flex justify-content-center mt-3">
                            <mat-spinner diameter="30" *ngIf="isModelosLoading"></mat-spinner>
                            <mat-radio-group
                                class="d-flex flex-column"
                                formControlName="modelo">
                                    <mat-radio-button
                                        *ngFor="let modelo of modelos"
                                        [value]="modelo">

                                        <span class="d-inline-flex align-items-center">
                                            <span>{{modelo.batchTemplate?.name}}</span>
                                            <button
                                                mat-icon-button
                                                color="primary"
                                                matTooltip="Ver detalle" 
                                                [matTooltipPosition]="'right'"
                                                (click)="openTemplateDetail(modelo)">
                                                <mat-icon>info</mat-icon>
                                            </button>
                                        </span>
                                    </mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <div class="col-12 d-flex justify-content-end mt-3">
                            <button
                                [disabled]="!processAssignForm.controls.modelo.value"
                                mat-flat-button
                                matStepperNext
                                type="button"
                                class="custom-button-primary">
                                <mat-icon class="ml-3" iconPositionEnd>arrow_forward</mat-icon>
                                Continuar
                            </button>
                        </div>
                    </mat-step>
                    <mat-step label="Frecuencia" [stepControl]="processAssignForm.controls.frecuencia">
                        <div class="col-12 d-flex justify-content-center mt-3">
                            <mat-radio-group
                                class="d-flex flex-column"
                                formControlName="frecuencia">
                                <mat-radio-button
                                    *ngFor="let frecuencia of frecuencias"
                                    [value]="frecuencia">
                                    {{ frecuencia.description ? frecuencia.description : frecuencia.name }}
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <div class="col-12 d-flex justify-content-end mt-3">
                            <button mat-flat-button class="custom-button-basic" type="button" matStepperPrevious>Volver</button>
                            <button
                                [disabled]="!processAssignForm.controls.frecuencia.value"
                                mat-flat-button
                                matStepperNext
                                type="button"
                                class="custom-button-primary">
                                <mat-icon class="ml-3" iconPositionEnd>arrow_forward</mat-icon>
                                Continuar
                            </button>
                        </div>
                    </mat-step>
                    <mat-step label="Formato Extracción" [stepControl]="processAssignForm.controls.query">
                        <div class="col-12 d-flex justify-content-center mt-3">
                            <mat-spinner diameter="30" *ngIf="isMappersLoading"></mat-spinner>
                            <mat-radio-group
                                class="d-flex flex-column"
                                formControlName="query">

                                <mat-radio-button
                                    *ngFor="let query of queries"
                                    [value]="query">

                                    <span class="d-inline-flex align-items-center">
                                        <span>{{ query.name }}</span>
                                        <button
                                            mat-icon-button
                                            color="primary"
                                            matTooltip="Ver detalle" 
                                            [matTooltipPosition]="'right'"
                                            (click)="openQueryDetail(query.id)">
                                            <mat-icon>info</mat-icon>
                                        </button>
                                    </span>
                                </mat-radio-button>

                                <div *ngIf="queries.length == 0 && !isMappersLoading">No hay queries disponibles para este modelo</div>
                            </mat-radio-group>
                        </div>
                        <div class="col-12 d-flex justify-content-center mt-3">
                            <button mat-flat-button class="custom-button-basic" type="button" matStepperPrevious>Volver</button>
                            <button
                                [disabled]="!processAssignForm.controls.query.value"
                                mat-flat-button
                                matStepperNext
                                type="button"
                                class="custom-button-primary"
                                (click)="asignConfig()">
                                <mat-icon class="ml-3" iconPositionEnd>check</mat-icon>
                                Asignar
                            </button>
                        </div>
                    </mat-step>
                    <mat-step label="Resultado" [editable]="false">

                        <div *ngIf="isAsigning">
                            <ng-container *ngIf="processAssignForm.valid; else errorTemplate">
                                <div class="col-12 d-flex flex-column justify-content-center align-items-center mt-3">
                                    <mat-spinner diameter="30"></mat-spinner>
                                    <h3>Asignando proceso ...</h3>
                                </div>
                            </ng-container>
                            <ng-template #errorTemplate>
                                <div class="col-12 d-flex justify-content-center mt-3">
                                    <h3>Por favor, complete todos los pasos antes de asignar el proceso.</h3>
                                </div>
                                <div class="col-12 d-flex justify-content-end mt-3">
                                    <button mat-flat-button class="custom-button-basic" type="button" matStepperPrevious>Volver</button>
                                </div>
                            </ng-template>
                        </div>

                        <div *ngIf="!isAsigning">
                            <div class="col-12 d-flex justify-content-center mt-3">
                                <mat-icon color="primary" class="big-icon">check_circle_outline</mat-icon>
                            </div>
                            <div class="col-12 d-flex justify-content-center mt-3">
                                <h3>Proceso Asignado correctamente</h3>
                            </div>
                            <div class="col-12 d-flex justify-content-center mt-3">
                                <button
                                    mat-flat-button
                                    class="custom-button-primary"
                                    (click)="restartStepper()">
                                    Asignar otro proceso
                                </button>
                            </div>
                        </div>
                    </mat-step>
                </mat-stepper>
            </div>
        </mat-card-content>
    </mat-card>
</div>